function formatMobilePhoneNumber(mobileNumber, locale = 'en-AU') {
  if (!mobileNumber) {
    return mobileNumber;
  }

  if (locale === 'en-AU') {
    if (mobileNumber.length < 10 && !mobileNumber.startsWith('0')) {
      return `0${mobileNumber}`;
    }

    if (mobileNumber.startsWith('+61')) {
      return mobileNumber.replace('+61', '0');
    }
  }

  return mobileNumber;
}

function replaceLocalCode(mobileNumber) {
  if (!mobileNumber) {
    return mobileNumber;
  }

  if (mobileNumber.startsWith('+61')) {
    return mobileNumber.replace('+61', '');
  }

  return mobileNumber;
}

function maskMobilePhoneNumber(mobileNumber) {
  if (!mobileNumber) {
    return mobileNumber;
  }
  return `******${mobileNumber.slice(-4)}`;
}

const phoneNumberUtils = {
  formatMobilePhoneNumber,
  replaceLocalCode,
  maskMobilePhoneNumber,
};

export default phoneNumberUtils;
